__webpack_require__.p = "/reports-remove-deprecated-features/referrals-hub/";